import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ICampaign, EmailPreference, CampaignStatus, campaignModel, ModalData } from '../../model/campaign';
import { MatPaginator } from '@angular/material/paginator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCampaignModalComponent } from '../create-campaign-modal/create-campaign-modal.component';
import { Router } from '@angular/router';
import { CampaignService } from 'src/app/_services/campaign.service';
import { SharedService } from '../shared-service.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
  selector: 'app-email-campaign-create-campaign',
  templateUrl: './email-campaign-create-campaign.component.html',
  styleUrls: ['./email-campaign-create-campaign.component.scss']
})
export class EmailCampaignCreateCampaignComponent implements OnInit {
  modalData: ModalData = {campaignName: ''};
  successMessage: string;
  errorMessage: string;

  constructor(private modalService: NgbModal, private router: Router, private emailCampaignService : CampaignService, private sharedService: SharedService, private localStorageService: LocalStorageService){}
  // Sample data
  campaigns: campaignModel[] = [];
  displayCampaigns: campaignModel[];
  // MatTableDataSource to manage the table data
  dataSource = new MatTableDataSource<campaignModel >(this.campaigns);
  campaign_name: string = '';
  status: number | string;
  // MatPaginator for pagination
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  /**Used to check GetCampaigns api called or not */
  isCampaignsCalled: boolean = false;
  
  // Define the table columns
  displayedColumns: string[] = [
    'campaign_name',
    'recipients',
    'pipeline',
    'completed',
    'opened',
    'replied',
    // 'bounced',
    // 'created_by',
    'created_on',
    'status',
  ];
  
  // currentPage: number = 1;
  // itemsPerPage: number = 10;
  // totalPages: number;

  statuses = [
    {
      value: 1,
      status: "Active"
    },
    {
      value:2,
      status: "Paused"
    },
    {
      value: 3,
      status: "Draft"
    },
    // {
    //   value: 4,
    //   status: 'Completed',
    // },
    // {
    //   value: 5,
    //   status: 'Integration Error',
    // }
  ]
  startIndex:  number = 0;
  endIndex: number = 10;
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 0;
  totalCount: number = 0;
  userId: number = this.localStorageService.getItem('userdata').userid

  ngOnInit() {
    // this.totalPages = Math.ceil(this.campaigns.length / this.itemsPerPage);
    // this.displayCampaigns = this.campaigns.slice(0, this.itemsPerPage);
    this.dataSource.paginator = this.paginator;
    this.getCampaigns({page:0, limit: 10, created_by: this.userId});
    type k1 = keyof campaignModel;
  }
  // get startIndex(): number {
  //   return (this.currentPage - 1) * this.itemsPerPage;
  // }

  // get endIndex(): number {
  //   return this.startIndex + this.itemsPerPage;
  // }

  // get paginatedCampaigns(): campaignModel[] {
  //   return this.campaigns.slice(this.startIndex, this.endIndex);
  // }

  createCampaign(){
    const modalRef = this.modalService.open(CreateCampaignModalComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.modalData = this.modalData;
    modalRef.componentInstance.dataAdded.subscribe((data: ModalData) => {
      // Handle the data added from the modal
      const Campaign ={
        campaign_name: (data.campaignName).trim(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        schedule: "10:00-17:00",
        status: CampaignStatus.Draft
      } 
      // Call the emailCampaignService to create a new campaign based on data
      this.emailCampaignService.getCampaigns({created_by: this.userId, campaign_name: Campaign.campaign_name}).subscribe((res:any)=>{
        if(res?.data.length>0){
          const temp = res?.data.filter(x=> x.campaign_name===Campaign.campaign_name)
          if(temp && temp.length>0){
            modalRef.componentInstance.duplicateCampaignNameError = "Campaign name already exists";
          }
          else{
            this.emailCampaignService.createCampaign(Campaign).subscribe(
              (result:any) => {
                if(result.status=='success'){
      
                  modalRef.close(); 
                  
                  this.router.navigate(['/email-campaign/create-campaign-stages',  result['data'].campaign_id ]) // Navigate to the campaign details page after data is added
                }
                else if(result.status=='failure'){
                  modalRef.close(); 
                  this.errorMessage = result && result.message? result.message : 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
                }
              },
              (error) => {
                this.errorMessage = 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
              }
            );
            // this.router.navigate(['/email-campaign/create-campaign-stages']); // Navigate to the campaign details page after data is added
          }
        }
        else{
            this.emailCampaignService.createCampaign(Campaign).subscribe(
              (result:any) => {
                if(result.status=='success'){
      
                  modalRef.close(); 
                  
                  this.router.navigate(['/email-campaign/create-campaign-stages',  result['data'].campaign_id ]) // Navigate to the campaign details page after data is added
                }
                else if(result.status=='failure'){
                  modalRef.close(); 
                  this.errorMessage = result && result.message? result.message : 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
                }
              },
              (error) => {
                this.errorMessage = 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
              }
            );
            // this.router.navigate(['/email-campaign/create-campaign-stages']); // Navigate to the campaign details page after data is added
        }
      })
     
    }); 
  }
  getCampaigns(data: {}= { created_by: this.userId}) {
    // const tempData = this.campaigns;
    // this.displayCampaigns = tempData.slice(this.startIndex, this.endIndex);
    this.emailCampaignService.getCampaigns(data).subscribe(
      (data: any[]) => {
        this.campaigns = data['data'];
        if(this.campaigns && this.campaigns.length ==0){
          this.router.navigate(['/email-campaign/dashboard']); // Navigate to the campaign details page after data is added
          return;
        }
        // data['data'].map((x,i)=> {this.campaigns[i].name=x.campaign_name;
        // this.campaigns[i]['created_by']= x.created_by});
        this.totalPages = Math.ceil(data['total']/ this.pageSize);
        this.totalCount = data['total'];
        // if(this.totalCount==0)
        //   this.createCampaign()
        // this.totalCount = ???
        this.isCampaignsCalled = true
      },
      error => {
        console.error('Error getting campaigns:', error);
      }
    );
  }
  onPageChange(index: number) {
    // this.displayCampaigns = this.campaigns.slice((page - 1) * this.itemsPerPage, page * this.itemsPerPage);
    // this.currentPage = page;
    this.startIndex = (index - 1) * this.pageSize;
    this.endIndex = this.startIndex + this.pageSize;
    this.currentPage = index;
    if(this.status)
    this.getCampaigns({page:this.currentPage-1, limit:10, status: this.status,  created_by: this.userId});
    else
    this.getCampaigns({page:this.currentPage-1, limit:10,  created_by: this.userId});
  }
  getStatus(status: number){
    if(status === 1) return 'Active';
    if(status === 2) return 'Draft';
    if(status === 3) return 'Paused';
    if(status === 4) return 'Completed';
    if(status === 5) return 'IntegrationError';
    return 'Unknown';

  }
  filterCampaign(event, type){
    let payload = {page:0, limit: 10}
    if(type === 'input') {
      this.campaign_name = event;
    }
    else { 
      this.status = event;
    }
    if(this.campaign_name.length)
      payload['campaign_name']=this.campaign_name;
    if(this.status && this.status!=='0'){
      this.currentPage  = 1;
      payload['status']=this.status;
    }
    // payload['created_by'] = this.userId;
    this.emailCampaignService.getCampaigns(payload).subscribe(
      res=>{
        this.campaigns = res['data'];
        this.totalPages = Math.ceil(res['total']/ this.pageSize);
        this.totalCount = res['total'];
        // this.totalCount = ???
      }
    )
  }
  
  changeStatus(event, element){
    this.emailCampaignService.getStages(element.campaign_id).subscribe(res=>{
      if(res && res['data'] && res['data'].length){
        this.emailCampaignService.updateCampaign( {status: event.target.value, campaign_id: element.campaign_id}).subscribe(res=>{
          this.getCampaigns({page:0, limit: 10,  created_by: this.userId});
          this.successMessage = 'Status updated';
          setTimeout(() => this.successMessage = '', 5000);
          const selectElement = document.getElementById('statusDropdown') as HTMLSelectElement;
          if (selectElement) {
            //@ts-ignore
            selectElement.value = 0;
          }
        })
      }
      else{
        this.errorMessage = 'Add stages before updateing status';
        setTimeout(() => this.errorMessage = '', 5000);
      }
        this.getCampaigns({page:0, limit: 10,  created_by: this.userId})
    })
  }
  redirectToListing(campaign_details){
    //redirect to email-campaign/target-listing
    this.emailCampaignService.getStages(campaign_details.campaign_id).subscribe(res=>{
      if(res && res['data'] && res['data'].length && campaign_details.status!==3)
        this.router.navigate(['/email-campaign/target-listing/'+ campaign_details.campaign_id]);
      else
      this.router.navigate(['/email-campaign/create-campaign-stages/'+ campaign_details.campaign_id]);
    })
  }
}
